import { NavigationGroup, NavigationSection, NavigationState } from '@common/store/navigation/models/navigation.models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ViewStateTypesEnum } from '@src/suite/common/enums/viewstate-types';

const selectNavigationState = createFeatureSelector<NavigationState>('navigation');

export const selectNavigationData = createSelector(selectNavigationState, state => state);

export const selectCurrentApplication = createSelector(selectNavigationState, (state: NavigationState) => state.application);

export const selectCurrentGroup = createSelector(selectNavigationState, (state: NavigationState) => state.group);

export const selectCurrentSection = createSelector(selectNavigationState, (state: NavigationState) => state.section);

export const selectCurrentItem = createSelector(selectNavigationState, (state: NavigationState) => state.item);

export const selectGroups = createSelector(selectNavigationState, (state: NavigationState) => state.navigation[state.application]);

export const selectSystemGroup = createSelector(selectGroups, (groups: Array<NavigationGroup>) => {
    return groups.find(item => item.path === 'system');
});

export const selectSystemSection = createSelector(selectSystemGroup, (group: NavigationGroup) => {
    return group.items.find(item => item.path === 'system');
});

export const selectSystemSingleViewStateItem = createSelector(selectSystemSection, (section: NavigationSection) => {
    return section.items.find(item => item && item.viewState && item.viewState.viewStateType === ViewStateTypesEnum.SINGLEITEM);
});

export const selectGroup = (args: { group: string }) =>
    createSelector(selectGroups, (groups: Array<NavigationGroup>) => {
        return groups.filter(item => item.path === args.group);
    });
